import {
  OnInit,
  Component,
  ViewEncapsulation,
  ChangeDetectionStrategy,
  Input,
} from '@angular/core';

import { FusuIconService } from './service/fusus-icon.service';

@Component({
  selector: 'sn-fusus-icon',
  templateUrl: './fusus-icons.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  encapsulation: ViewEncapsulation.None,
  inputs: ['size', 'inline', 'svgIcon', 'fontSet', 'fontIcon', 'clickable', 'path'],
})
export class SnFususIconComponent implements OnInit {
  @Input() public fontIcon: string;
  public icons: any;

  constructor(private readonly _fususIcon: FusuIconService) {}

  public ngOnInit(): void {
    this.icons = this._fususIcon.getIcons(this.fontIcon);
  }
}
